import { AllowAccountRes } from '../../api/orderManage'
import { RouteParams } from './hooks'

interface State {
  dataSource: AllowAccountRes[]
  isAddModalVisivle: boolean
  selectedRowKeys: string[]
  selectedRows: AllowAccountRes[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
  routeParams: RouteParams
  originRemovedList: AllowAccountRes[]
}

type ActionType =
  | 'setDataSource'
  | 'setSelectedRowKeys'
  | 'setSelectedRows'
  | 'setIsAddModalVisivle'
  | 'setInvoiceData'
  | 'setFormDataAction'
  | 'setIsSubmitButtonLoadingAction'
  | 'setRouteParamsAction'
  | 'reloadStateAction'
  | 'setOriginRemovedListAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  selectedRows: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
  routeParams: {
    data: [],
  },
  originRemovedList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setIsAddModalVisivle':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setOriginRemovedListAction':
      newstate.originRemovedList = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivle = (val: any): Action => ({
  type: 'setIsAddModalVisivle',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceData = (val: any[]): Action => ({
  type: 'setInvoiceData',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

// 路由参数
export const setRouteParamsAction = (val: RouteParams): Action => ({
  type: 'setRouteParamsAction',
  payload: val,
})

// 重载数据
export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})

// 原始对账单被删除的订单
export const setOriginRemovedListAction = (val: AllowAccountRes[]): Action => ({
  type: 'setOriginRemovedListAction',
  payload: val,
})
import { AllowAccountRes } from '../../api/orderManage'
import { RouteParams } from './hooks'

interface State {
  dataSource: AllowAccountRes[]
  isAddModalVisivle: boolean
  selectedRowKeys: string[]
  selectedRows: AllowAccountRes[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
  routeParams: RouteParams
  originRemovedList: AllowAccountRes[]
}

type ActionType =
  | 'setDataSource'
  | 'setSelectedRowKeys'
  | 'setSelectedRows'
  | 'setIsAddModalVisivle'
  | 'setInvoiceData'
  | 'setFormDataAction'
  | 'setIsSubmitButtonLoadingAction'
  | 'setRouteParamsAction'
  | 'reloadStateAction'
  | 'setOriginRemovedListAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  selectedRows: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
  routeParams: {
    data: [],
  },
  originRemovedList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setIsAddModalVisivle':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setOriginRemovedListAction':
      newstate.originRemovedList = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivle = (val: any): Action => ({
  type: 'setIsAddModalVisivle',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceData = (val: any[]): Action => ({
  type: 'setInvoiceData',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

// 路由参数
export const setRouteParamsAction = (val: RouteParams): Action => ({
  type: 'setRouteParamsAction',
  payload: val,
})

// 重载数据
export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})

// 原始对账单被删除的订单
export const setOriginRemovedListAction = (val: AllowAccountRes[]): Action => ({
  type: 'setOriginRemovedListAction',
  payload: val,
})
